export default __webpack_public_path__ + "static/media/Leonardo_1.65d69eb1.webp";